<!-- 人才政策文章卡片 组件 -->
<template>
  <div>
    <a
      v-if="detail.jumpurl"
      :href="detail.jumpurl"
      target="_blank"
      class="group relative flex h-[197px] items-center rounded-3xl bg-[#f8f9fd] px-[33px] hover:shadow-sm"
      style="background-color: #f8f9fd"
    >
      <div>
        <img :src="this.$getImageSrc('icon-book.png')" alt="" />
      </div>
      <div class="ml-[43px] flex-1">
        <h2 class="mb-[10px] line-clamp-1 text-[24px] font-bold">
          {{ detail.title }}
        </h2>
        <p class="line-clamp-2 text-[#919191]">
          {{ detail.detail }}
        </p>
      </div>
      <span class="absolute bottom-[14px] right-[33px] flex items-center text-[14px] text-[#1267d3]">
        查看更多
        <Icon icon="ant-design:plus-outlined" class="relative left-0 text-[15px] transition-all group-hover:left-2" />
      </span>
    </a>
    <router-link
      v-else
      :to="{ path: '/detail', query: { channel: 'policy', id: detail.talent_policy_id } }"
      class="group relative flex h-[197px] items-center rounded-3xl bg-[#f8f9fd] px-[33px] hover:shadow-sm"
    >
      <div>
        <img :src="this.$getImageSrc('icon-book.png')" alt="" />
      </div>
      <div class="ml-[43px] flex-1">
        <h2 class="mb-[10px] line-clamp-1 text-[24px] font-bold">
          {{ detail.title }}
        </h2>
        <p class="line-clamp-2 text-[#919191]">
          {{ detail.detail }}
        </p>
      </div>
      <span class="absolute bottom-[14px] right-[33px] flex items-center text-[14px] text-[#1267d3]">
        查看更多
        <Icon icon="ant-design:plus-outlined" class="relative left-0 text-[15px] transition-all group-hover:left-2" />
      </span>
    </router-link>
  </div>
</template>

<script>
import { Icon } from '@iconify/vue2';

export default {
  name: 'TalentPolicyCard',
  components: {
    Icon,
  },
  props: {
    detail: {
      type: Object,
      default: () => ({
        talent_policy_id: '',
        title: '',
        description: '',
        detail: '',
        keyword: '',
        jumpurl: '',
        sortid: '',
        status: '',
        create_time: '',
        update_time: '',
      }),
    },
  },
};
</script>

<style lang="scss" scoped></style>
